import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";

// material-ui components
import withStyles from "@material-ui/core/styles/withStyles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
// core components
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import Terminal from "components/Terminal/Terminal.jsx";

import customTabsStyle from "assets/jss/material-dashboard-react/components/customTabsStyle.jsx";

import httpr from "lib/httpRequest";
import { BASE_URL } from "lib/config";
import ReactLoading from "react-loading";

class DashboardTabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      subValue: 0,
      locations: [],
      isLoading: true,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    // get locations from chosen org
    if (this.props.tabs.length > 0) {
      if (this.props.tabs.length !== prevProps.tabs.length) {
        // initial location load
        this.getLocations();
      } else if (this.state.value !== prevState.value) {
        this.setState({ isLoading: !this.state.isLoading });
        this.getLocations();
      }
    }
  }

  getLocations() {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);
    return new Promise(async (resolve, reject) => {
      fetch
        .get(`${BASE_URL}${this.props.tabs[this.state.value].dataUrl}`)
        .then((response) => {
          this.setState({ locations: response.data, isLoading: false });
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }

  handleChange = (event, value) => {
    this.setState({
      value,
      subValue: 0,
    });
  };

  handleSubTabChange = (event, value) => {
    this.setState({
      subValue: value,
    });
  };

  getKey() {
    return Math.floor(Math.random() * 100);
  }

  render() {
    const {
      canSubTabs,
      classes,
      headerColor,
      plainTabs,
      tabs,
      title,
      subtitle,
      rtlActive,
    } = this.props;

    const cardTitle = classNames({
      [classes.cardTitle]: true,
      [classes.cardTitleRTL]: rtlActive,
    });

    if (canSubTabs) {
      let dataUrl = [];
      tabs.forEach((prop, key) => {
        dataUrl.push(prop.dataUrl);
      });

      const mainTabs = tabs.map((prop, key) => {
        var icon = {};
        if (prop.tabIcon) {
          icon = {
            icon: <prop.tabIcon />,
          };
        }
        return (
          <Tab
            classes={{
              root: classes.tabRootButton,
              labelContainer: classes.tabLabelContainer,
              label: classes.tabLabel,
              selected: classes.tabSelected,
              wrapper: classes.tabWrapper,
            }}
            key={key}
            label={prop.tabName.replace(/_/g, " ")}
            {...icon}
          />
        );
      });

      return (
        <div key={this.getKey()}>
          {tabs.map((prop, key) => {
            if (key === this.state.value) {
              if (this.state.isLoading) {
                return (
                  <Card plain={plainTabs} key={key}>
                    <CardHeader color={headerColor} plain={plainTabs}>
                      {title !== undefined ? (
                        <div className={cardTitle}>{title}</div>
                      ) : null}

                      <Tabs
                        key={`MainTab${key}`}
                        value={this.state.value}
                        onChange={this.handleChange}
                        classes={{
                          root: classes.tabsRoot,
                          indicator: classes.displayNone,
                        }}
                        scrollable
                        scrollButtons="auto"
                        variant="scrollable"
                      >
                        {mainTabs}
                      </Tabs>
                    </CardHeader>
                    <CardBody>
                      <ReactLoading
                        type="spin"
                        color="#000000"
                        style={{
                          width: "20%",
                          margin: "auto",
                        }}
                      />
                    </CardBody>
                  </Card>
                );
              } else {
                return (
                  <Card plain={plainTabs} key={key}>
                    <CardHeader color={headerColor} plain={plainTabs}>
                      {title !== undefined ? (
                        <div className={cardTitle}>{title}</div>
                      ) : null}

                      <Tabs
                        key={`MainTab${key}`}
                        value={this.state.value}
                        onChange={this.handleChange}
                        classes={{
                          root: classes.tabsRoot,
                          indicator: classes.displayNone,
                        }}
                        scrollable
                        scrollButtons="auto"
                        variant="scrollable"
                      >
                        {mainTabs}
                      </Tabs>

                      <div className={cardTitle}>{subtitle}</div>
                      <Tabs
                        key={`SubTab${key}`}
                        value={this.state.subValue}
                        onChange={this.handleSubTabChange}
                        classes={{
                          root: classes.tabsRoot,
                          indicator: classes.displayNone,
                        }}
                        scrollable
                        scrollButtons="auto"
                        variant="scrollable"
                      >
                        {this.state.locations.map((loc, key) => {
                          var icon = {};
                          return (
                            <Tab
                              classes={{
                                root: classes.tabRootButton,
                                labelContainer: classes.tabLabelContainer,
                                label: classes.tabLabel,
                                selected: classes.subTabSelected,
                                wrapper: classes.tabWrapper,
                              }}
                              key={loc.LocationId}
                              label={loc.LocationName.replace(/_/g, " ")}
                              {...icon}
                            />
                          );
                        })}
                      </Tabs>
                    </CardHeader>
                    <CardBody>
                      {this.state.locations.map((loc, key) => {
                        const isSD = loc.LocationId === 1 ? true : false;
                        if (key === this.state.subValue) {
                          return (
                            <Terminal
                              isSocalDemo={isSD}
                              key={key}
                              dataUrl={`/api/terminal/location/${
                                loc.LocationId
                              }`}
                              locationId={loc.LocationId}
                            />
                          );
                        }
                        return null;
                      })}
                    </CardBody>
                  </Card>
                );
              }
            }
          })}
        </div>
      );
    }
  }
}

DashboardTabs.propTypes = {
  classes: PropTypes.object.isRequired,
  headerColor: PropTypes.oneOf([
    "warning",
    "success",
    "scmain",
    "danger",
    "info",
    "primary",
  ]),
  title: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      tabName: PropTypes.string.isRequired,
      tabIcon: PropTypes.func,
      tabContent: PropTypes.node.isRequired,
    })
  ),
  rtlActive: PropTypes.bool,
  plainTabs: PropTypes.bool,
};

export default withStyles(customTabsStyle)(DashboardTabs);



// WEBPACK FOOTER //
// ./src/components/CustomTabs/DashboardTabs.jsx